module.exports = __webpack_public_path__ + "img/new-loader.4bb46505.png";